<template>
  <v-dialog v-model="dialog" width="400" persistent>
    <v-card>
      <ValidationObserver ref="formObserver" v-slot="{ invalid, validate }">
        <v-form @submit.prevent="handleSubmit(validate)">
          <v-card-title>
            {{ __("adicionar bairro") }}
            <v-spacer></v-spacer>
            <v-btn @click="close()" icon>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-alert
              :value="hasErrors"
              type="error"
              dense
              v-text="errorMessage"
            ></v-alert>

            <ValidationProvider
              name="address.neighborhood"
              rules="required|max:255"
              v-slot="{ errors }"
            >
              <v-text-field
                v-model="form.name"
                :error-messages="errors.length ? errors : backendErrors.name"
                :label="__('Bairro')"
                outlined
              ></v-text-field>
            </ValidationProvider>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="close()" text>
              {{ __("cancelar") }}
            </v-btn>
            <v-btn type="submit" color="primary">
              {{ __("salvar") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
import FormDialogMixin from "@/mixins/FormDialogMixin";
import { storeNeighborhood } from "@/services/locals.js";
import i18n from "@/mixins/i18n";

export default {
  mixins: [FormDialogMixin, i18n],

  data() {
    return {
      i18n_prefix: "address",
      form: {
        name: "",
        city_id: null,
      },
    };
  },

  computed: {
    backendErrors() {
      return this.errors || {};
    },
  },

  methods: {
    async getSubmitQuery(form) {
      return await storeNeighborhood(form);
    },
    open(cityId) {
      this.form.city_id = cityId;
      this.dialog = true;
    },
    async handleSubmit(validate) {
      const valid = await validate();
      if (!valid) {
        this.hasErrors = true;
        this.errorMessage = this.__(
          "preencha os campos obrigatórios corretamente",
          "address"
        );
        return;
      }
      await this.submit();
    },
    resetForm() {
      this.form = {
        name: "",
        city_id: null,
      };
      this.errors = {};
      this.hasErrors = false;
      this.errorMessage = "";
      this.$refs.formObserver?.reset();
    },
    close() {
      this.resetForm();
      this.dialog = false;
    },
  },
};
</script>
